import { render, staticRenderFns } from "./Correctness.vue?vue&type=template&id=25723bc2&scoped=true&"
import script from "./Correctness.vue?vue&type=script&lang=js&"
export * from "./Correctness.vue?vue&type=script&lang=js&"
import style0 from "./Correctness.vue?vue&type=style&index=0&id=25723bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25723bc2",
  null
  
)

export default component.exports